exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TrainingEditor-module__wrapper___UCXC6{display:grid;gap:1.5rem}.TrainingEditor-module__wrapper___UCXC6 h2{margin-bottom:.5rem}.TrainingEditor-module__wrapper___UCXC6 h2 span{font-family:Lato,arial}.TrainingEditor-module__wrapper___UCXC6 .TrainingEditor-module__text___3IB7M{font-size:14px;color:#b4bac3;margin-bottom:.5rem}.TrainingEditor-module__wrapper___UCXC6 a{display:inline;color:#0827e9;font-size:14px}.TrainingEditor-module__wrapper___UCXC6 .TrainingEditor-module__upload-wrapper___3PCzk{margin-left:-.25rem;margin-bottom:.5rem}.TrainingEditor-module__bar___PGuaX{margin:2.5rem 0;width:100%;height:2px;background-color:#ececec}", ""]);

// exports
exports.locals = {
	"wrapper": "TrainingEditor-module__wrapper___UCXC6",
	"text": "TrainingEditor-module__text___3IB7M",
	"upload-wrapper": "TrainingEditor-module__upload-wrapper___3PCzk",
	"bar": "TrainingEditor-module__bar___PGuaX"
};